import PropTypes from "prop-types";

const Checkbox = (props) => {
  const { label, disabled, onChange, name, value, checked, className } = props;
  return (
    <div className="flex justify-start items-center">
      <input
        onChange={onChange}
        disabled={disabled}
        className={`mr-2 ${className}`}
        type="checkbox"
        checked={checked}
        value={value}
        name={name}
      />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
};

export default Checkbox;
